import { Leaf, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-darktext text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Leaf className="text-accent w-7 h-7" />
              <div>
                <div className="font-display font-bold text-lg leading-tight">Silver Line</div>
                <div className="text-xs text-accent/80 tracking-widest uppercase">Homeo Care</div>
              </div>
            </div>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              Natural, safe, and effective homeopathic treatments tailored to your unique needs.
              Care for Cure.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-display font-semibold text-white mb-4">Quick Links</h4>
            <ul className="flex flex-col gap-2">
              {[
                { label: "Home", href: "#home" },
                { label: "Services", href: "#services" },
                { label: "Blogs", href: "#blogs" },
                { label: "Reviews", href: "#reviews" },
                { label: "About Us", href: "#about" },
                { label: "Contact Us", href: "#contact" },
              ].map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => scrollTo(link.href)}
                    className="text-white/60 hover:text-accent text-sm transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h4 className="font-display font-semibold text-white mb-4">Contact</h4>
            <ul className="flex flex-col gap-3">
              <li>
                <a
                  href="tel:+919890900292"
                  className="flex items-center gap-2 text-white/60 hover:text-accent text-sm transition-colors"
                >
                  <Phone className="w-4 h-4 flex-shrink-0" />
                  +91-98-90-900-292
                </a>
              </li>
              <li>
                <a
                  href="mailto:silverlinehomeo@gmail.com"
                  className="flex items-center gap-2 text-white/60 hover:text-accent text-sm transition-colors"
                >
                  <Mail className="w-4 h-4 flex-shrink-0" />
                  silverlinehomeo@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2 text-white/60 text-sm">
                <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <span>
                  101, 1st Floor, Janki Crystal, Opposite Talegaonkar Hardware, Vikas Nagar,
                  Dehu Road, Maharashtra 412101
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 text-center">
          <p className="text-white/40 text-xs">
            Copyright &copy; {year} All rights reserved ❤ by Silver Line Homeo Care
          </p>
        </div>
      </div>
    </footer>
  );
}
